import styles from './Privacy.scss';
import Head from 'next/head';
import { useSchoolContext } from '@/hooks/school';

/** Privacy */
export const Privacy: React.FC = () => {
  const { school } = useSchoolContext();
  return (
    <>
      <Head>
        <title>プライバシーポリシー - {school?.company.name}</title>
      </Head>
      <main>
        <h2>プライバシーポリシー</h2>
        <p>
          当スクールは、お客様の個人情報保護の重要性について認識し、個人情報の保護に関する法律（平成15年法律第57号。以下「個人情報保護法」といいます。）を遵守するとともに、以下のプライバシーポリシー（以下「本ポリシー」といいます。）に従い、個人情報の適切な取扱いに努めます。
        </p>
        <section>
          <h3>1. 個人情報の定義</h3>
          <p>本ポリシーにおいて、個人情報とは、個人情報保護法第2条第1項所定の個人情報をいいます。</p>
        </section>
        <section>
          <h3>2. 個人情報の利用目的</h3>
          <p>当スクールは、お客様の個人情報を、以下の目的で利用致します。</p>

          <ul>
            <li>（１） 当スクールの提供のため、お客様から取得した情報を利用します。</li>
            <li>
              （２）
              当スクールに関するご案内、お問い合わせ等への対応のため、お客様から取得した氏名、住所、電話番号、メールアドレスその他の連絡先情報及びお客様の属性に関する情報を利用します。
            </li>
            <li>
              （３）
              当スクールに関する当スクールの利用規約及び本ポリシー等（以下「規約等」といいます。）に違反する行為に対する対応のため、お客様から取得したアカウント登録情報その他のお客様の入力情報及びお客様の当スクールの利用履歴その他の当スクールの利用に関する情報を利用します。
            </li>
            <li>
              （４）
              当スクールに関する規約等の変更などを通知するため、お客様から取得した氏名、住所、電話番号、メールアドレスその他の連絡先情報及びお客様の属性に関する情報を利用します。
            </li>
            <li>
              （５）
              当スクールの改善等に役立てるため、お客様から取得したアカウント登録情報その他のお客様の入力情報及びお客様の当スクールの利用履歴その他の当スクールの利用に関する情報を利用します。
            </li>
            <li>
              （６）
              当スクールに関連して、個別を識別できない形式に加工した統計データを作成するため、お客様から取得した情報を利用します。
            </li>
            <li>
              （７）当スクールに関する広告、プロモーションのため、お客様から取得した氏名、住所、電話番号、メールアドレスその他の連絡先及びお客様の属性に関する情報を利用します。
            </li>
            <li>（８） その他、上記利用目的に付随する目的のため、お客様から取得した情報を利用します。</li>
          </ul>
        </section>

        <section>
          <h3>3. 個人情報の利用目的の変更</h3>
          <p>
            当スクールは、個人情報の利用目的につき、関連性を有すると合理的に認められる範囲内において変更することがあり、これを変更した場合には、お客様に通知し、又は公表します。
          </p>
        </section>
        <section>
          <h3>4. 個人情報の利用の制限</h3>
          <p>
            当スクールは、個人情報保護法その他法令により許容される場合を除き、お客様の同意を得ず、利用目的の達成に必要な範囲を超えて個人情報を取り扱いません。ただし、次に掲げる場合は、この限りではありません。
          </p>
          <ul>
            <li>（１） 法令に基づき公的機関が要請する場合</li>
            <li>
              （２） 人の生命、身体又は財産の保護のために必要がある場合であって、お客様の同意を得ることが困難であるとき
            </li>
            <li>
              （３）
              公衆衛生の向上又は児童の健全な育成の推進のために特に必要がある場合であって、お客様の同意を得ることが困難であるとき
            </li>
            <li>
              （４）
              国の機関若しくは地方公共団体又はそれらから委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、お客様の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがあるとき
            </li>
          </ul>
        </section>

        <section>
          <h3>5. 個人情報の適正な取得</h3>
          <p>当スクールは、適正に個人情報を取得し、偽りその他不正の手段により取得しません。</p>
        </section>

        <section>
          <h3>6. 個人情報の安全管理</h3>
          <p>
            当スクールは、個人情報の紛失、破壊、改ざん及び漏洩等のリスクに対して、個人情報の安全管理が図られるよう、当スクールの従業員に対し、必要かつ適切な監督を行います。また、当スクールは、個人情報の取扱いの全部又は一部を第三者に対して委託する場合は、委託先において個人情報の安全管理が図られるよう、必要かつ適切な監督を行います。
          </p>
          <p>
            当スクールは、外国の事業者が管理するサーバに個人情報を保管する場合がありますが、保管先において個人情報の安全管理が図られるよう当該外国の個人情報の保護に関する制度等を把握した上で、サーバへのアクセス権限等の厳格な管理を行います。
          </p>
        </section>

        <section>
          <h3>7. 第三者提供</h3>
          <p>
            当スクールは、個人情報保護法その他法令に基づき開示が認められる場合を除き、あらかじめお客様の同意を得ないで、個人情報を第三者に提供しません。ただし、次に掲げる場合は第三者への提供には該当しません。
          </p>
          <ul>
            <li>
              （１）
              当スクールが利用目的の達成に必要な範囲内において個人情報の取扱いの全部又は一部を委託することに伴って個人情報を提供する場合
            </li>
            <li>（２） 合併その他の事由による事業の承継に伴って個人情報が提供される場合</li>
          </ul>
        </section>
        <section>
          <h3>8. 個人情報の開示</h3>
          <p>
            当スクールは、お客様から、個人情報保護法に基づき個人情報の開示を求められたときは、お客様ご本人からのご請求であることを確認した上で、お客様に対し、お客様の費用負担において遅滞なく開示を行います（当該個人情報が存在しないときにはその旨を通知いたします。）。ただし、個人情報保護法その他法令により、当スクールが開示の義務を負わない場合、この限りではありません。
          </p>
        </section>

        <section>
          <h3>9. 個人情報の訂正等</h3>

          <p>
            当スクールは、お客様から、個人情報が真実でないという理由によって、個人情報保護法に基づきその内容の訂正、追加又は削除（以下「訂正等」といいます。）を求められた場合には、お客様ご本人からのご請求であることを確認の上で、利用目的の達成に必要な範囲内において、遅滞なく必要な調査を行い、その結果に基づき、個人情報の内容の訂正等を行い、その旨をお客様に通知します（訂正等を行わない旨の決定をしたときは、お客様に対しその旨を通知いたします。）。ただし、個人情報保護法その他の法令により、当スクールが訂正等の義務を負わない場合は、この限りではありません。
          </p>
        </section>
        <section>
          <h3>10. 個人情報の利用停止等</h3>
          <p>
            当スクールは、お客様から、お客様の個人情報が、あらかじめ公表された利用目的の範囲を超えて取り扱われているという理由又は偽りその他不正の手段により取得されたものであるという理由により、個人情報保護法に基づきその利用の停止又は消去（以下「利用停止等」といいます。）を求められた場合において、そのご請求に理由があることが明らかである場合には、お客様ご本人からのご請求であることを確認の上で、遅滞なく個人情報の利用停止等を行い、その旨お客様に通知します。ただし、個人情報保護法その他法令により、当スクールが利用停止等の義務を負わない場合は、この限りではありません。
          </p>
        </section>

        <section>
          <h3>11. Cookie（クッキー）その他技術の利用</h3>
          <p>
            当スクールのサービスは、Cookie及びこれに類する技術を利用することがあります。これらの技術は、当スクールによる当スクールのサービスの利用状況等の把握に役立ち、サービス向上に資するものです。Cookieを無効化されたいユーザーは、ウェブブラウザの設定を変更することによりCookieを無効化することができます。ただし、Cookieを無効化すると、当スクールのサービスの一部の機能をご利用いただけなくなる場合があります。
          </p>
        </section>

        <section>
          <h3>12. お問い合わせ</h3>
          <p>
            開示等のお申出、ご意見、ご質問、苦情のお申出その他個人情報の取扱いに関するお問い合わせは、当スクールの「特定商取引法に基づく表記」内にある連絡先へご連絡いただくか、スクールページ内のお問い合わせフォームよりお問い合わせください。
          </p>
        </section>

        <section>
          <h3>13. 継続的改善</h3>
          <p>
            当スクールは、個人情報の取扱いに関する運用状況を適宜見直し、継続的な改善に努めるものとし、必要に応じて本ポリシーを変更することがあります。
          </p>
        </section>
      </main>
      <style jsx>{styles}</style>
    </>
  );
};
